// @ts-nocheck
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import EventAddress from "@store/Library/Components/Events/Common/EventAddress";
import EventCategories from "@store/Library/Components/Events/Common/EventCategories";
import EventDate from "@store/Library/Components/Events/Common/EventDate";
import EventDescription from "@store/Library/Components/Events/Common/EventDescription";
import EventImage from "@store/Library/Components/Events/Common/EventImage";
import EventLink from "@store/Library/Components/Events/Common/EventLink";
import EventTitle from "@store/Library/Components/Events/Common/EventTitle";
import { AddressModel, CanadianTimeZones } from "@store/Library/Pages/EventDetailsPage";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    titleForwardAs?: keyof JSX.IntrinsicElements | undefined;
    eventLink?: string;
    startDate: Date;
    endDate?: Date;
    hideHourMinutes?: boolean;
    dateTimezone?: CanadianTimeZones;
    isLocalBranch?: boolean;
    localBranchTitle?: string;
    addressWrapper?: AddressModel[];
    previewImage: string;
    categoriesList?: string[];
    eventSummary: string;
    linkLabel: string;
    extendedStyles?: EventListTileStyles;
}

type Props = OwnProps;

export interface EventListTileStyles {
    wrapper?: GridContainerProps;
    imageGridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
}

export const eventListTileStyles: EventListTileStyles = {
    wrapper: {
        css: css`
            padding: ${pxToRem(30, 0)};
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    imageGridItem: {
        width: [12, 12, 4, 4, 4],
    },
    contentGridItem: {
        width: [12, 12, 8, 8, 8],
        css: css`
            flex-direction: column;
        `,
    },
};

const EventListTile = ({
    title,
    titleForwardAs,
    eventLink,
    startDate,
    endDate,
    hideHourMinutes,
    dateTimezone,
    isLocalBranch,
    localBranchTitle,
    addressWrapper,
    previewImage,
    categoriesList,
    eventSummary,
    linkLabel,
    extendedStyles,
}: Props) => {
    const styles = useMergeProps(eventListTileStyles, extendedStyles);

    return (
        <GridContainer {...styles.wrapper}>
            <GridItem {...styles.imageGridItem}>
                <EventImage
                    previewImage={previewImage}
                    altText={title}
                    eventLink={eventLink}
                    startDate={startDate}
                    endDate={endDate}
                />
            </GridItem>
            <GridItem {...styles.contentGridItem}>
                <EventCategories categoriesList={categoriesList} />
                <EventTitle title={title} eventLink={eventLink} forwardAs={titleForwardAs} />
                <EventDescription eventSummary={eventSummary} />
                <EventDate
                    startDate={startDate}
                    endDate={endDate}
                    dateTimezone={dateTimezone}
                    hideHourMinutes={hideHourMinutes}
                />
                <EventAddress
                    addressWrapper={addressWrapper}
                    isLocalBranch={isLocalBranch}
                    localBranchTitle={localBranchTitle}
                />
                <EventLink eventLink={eventLink} linkLabel={linkLabel} />
            </GridItem>
        </GridContainer>
    );
};

export default EventListTile;
